import { useState } from 'react';
import { Typography, Spin } from 'antd';
import { useSubscriptionSummary, useBillingPeriods } from '../hooks/useSubscriptions';
import { SubscriptionSummaryCards } from '../components/SubscriptionSummaryCards';
import { BillingAuditTable } from '../components/BillingAuditTable';

const { Title } = Typography;

export const SubscriptionsDashboard = () => {
    const [page, setPage] = useState(1);
    const [statusFilter, setStatusFilter] = useState<string | null>(null);

    const { data: summaryData, isLoading: isSummaryLoading } = useSubscriptionSummary();
    const { data: billingData, isLoading: isBillingLoading, isFetching: isBillingFetching } = useBillingPeriods(page, statusFilter);

    if (isSummaryLoading || isBillingLoading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
                <Spin size="large" />
            </div>
        );
    }

    return (
        <div style={{ padding: 24 }}>
            <Title level={3}>Subscriptions Dashboard</Title>

            <SubscriptionSummaryCards 
                summaryData={summaryData} 
                isLoading={false} 
            />

            <BillingAuditTable 
                billingData={billingData}
                isLoading={isBillingFetching}
                page={page}
                setPage={setPage}
                statusFilter={statusFilter}
                setStatusFilter={setStatusFilter}
            />
        </div>
    );
};
